export const brandColors = {
  blue: '#3b5998',
  orange: '#ca6914',
  teal: '#749ad3',
  white: '#ffffff',
}

export const defaultColors = {
  ...brandColors,
  primary: brandColors.blue,
  secondary: brandColors.teal,
  accent: brandColors.orange,
}
